import useDataStore from "../zustand/useDataStore";
const dataStore = useDataStore.getState();
export const getProductData = async () => {
  if (dataStore.products.length) {
    return dataStore.products;
  }
  const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/services`);
  const data = await response.json();

  const token = localStorage.getItem('authToken');
  const discountMultiplier = token ? 0.8 : 1;

  const discountedData = data.map(product => {
    const discountedProduct = { ...product };

    if (typeof discountedProduct.originalPrice === 'number') {
      discountedProduct.originalPrice = parseFloat((discountedProduct.originalPrice * discountMultiplier).toFixed(2));
    }

    if (Array.isArray(discountedProduct.button)) {
      discountedProduct.button = discountedProduct.button.map(button => {
        const updatedButton = { ...button };
        if (typeof updatedButton.originalPrice === 'number') {
          updatedButton.originalPrice = parseFloat((updatedButton.originalPrice * discountMultiplier).toFixed(2));
        }
        return updatedButton;
      });
    }

    return discountedProduct;
  });


  dataStore.setProducts(discountedData);
  return discountedData;
};

export const getBundleData = async () => {
  if (dataStore.bundles.length) {
    return dataStore.bundles;
  }

  const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/bundles`);
  const data = await response.json();

  const authUser = JSON.parse(localStorage.getItem("authUser"));
  if (authUser) {
    data.forEach(bundle => {
      if (bundle.heading === "3D Tour + VT Photos + Floor Plan") {
        bundle.discountedPrice = 148;
        bundle.originalPrice = 304;
      }
    });
  }

  dataStore.setBundles(data);
  return data;
};

export const getAddOnData = async () => {
  if (dataStore.addOns.length) {
    return dataStore.addOns;
  }

  const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/addons`);
  const data = await response.json();

  const authUser = JSON.parse(localStorage.getItem("authUser"));
  if (authUser) {
    data.forEach(addon => {
      addon.originalPrice = parseFloat((addon.originalPrice * 0.8).toFixed(2));
    });
  }
  dataStore.setAddOns(data);
  return data;
};
